package com.anjuros.website.templates.template6.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey : ResKeyType {



    TEMPLATE6_SECTION1,
    TEMPLATE6_SECTION2,
    TEMPLATE6_SECTION3,
    TEMPLATE6_SECTION4,
    TEMPLATE6_SECTION5,
    TEMPLATE6_SECTION6,


    TEMPLATE6_SERVICE1_TITLE,
    TEMPLATE6_SERVICE1_DESC1,
    TEMPLATE6_SERVICE1_DESC2,
    TEMPLATE6_SERVICE1_DESC3,
    TEMPLATE6_SERVICE1_DESC4,

    TEMPLATE6_SERVICE2_TITLE,
    TEMPLATE6_SERVICE2_DESC1,
    TEMPLATE6_SERVICE2_DESC2,
    TEMPLATE6_SERVICE2_DESC3,
    TEMPLATE6_SERVICE2_DESC4,

    TEMPLATE6_SERVICE3_TITLE,
    TEMPLATE6_SERVICE3_DESC1,
    TEMPLATE6_SERVICE3_DESC2,
    TEMPLATE6_SERVICE3_DESC3,
    TEMPLATE6_SERVICE3_DESC4,


    TEMPLATE6_REVIEW1_TITLE,
    TEMPLATE6_REVIEW1,
    TEMPLATE6_REVIEW2_TITLE,
    TEMPLATE6_REVIEW2,
    TEMPLATE6_REVIEW3_TITLE,
    TEMPLATE6_REVIEW3,
    TEMPLATE6_REVIEW4_TITLE,
    TEMPLATE6_REVIEW4,
    TEMPLATE6_REVIEW5_TITLE,
    TEMPLATE6_REVIEW5,
    TEMPLATE6_REVIEW6_TITLE,
    TEMPLATE6_REVIEW6,
    TEMPLATE6_REVIEW7_TITLE,
    TEMPLATE6_REVIEW7,
    TEMPLATE6_REVIEW8_TITLE,
    TEMPLATE6_REVIEW8,
    TEMPLATE6_REVIEW9_TITLE,
    TEMPLATE6_REVIEW9,

    TEMPLATE6_FAQ1_Q,
    TEMPLATE6_FAQ1_A,
    TEMPLATE6_FAQ2_Q,
    TEMPLATE6_FAQ2_A,
    TEMPLATE6_FAQ3_Q,
    TEMPLATE6_FAQ3_A,
    TEMPLATE6_FAQ4_Q,
    TEMPLATE6_FAQ4_A,
    TEMPLATE6_FAQ5_Q,
    TEMPLATE6_FAQ5_A,
    TEMPLATE6_FAQ6_Q,
    TEMPLATE6_FAQ6_A,



    TEMPLATE6_INFO_DESC1,
    TEMPLATE6_INFO_DESC2,
    TEMPLATE6_INFO_DESC3,
    TEMPLATE6_INFO_DESC4,
    TEMPLATE6_INFO_TITLE1,
    TEMPLATE6_INFO_TITLE2,
    TEMPLATE6_INFO_TITLE3,
    TEMPLATE6_INFO_TITLE4,

    TEMPLATE6_INFO_FOOTER,

    CONTACT_DROP1,
    CONTACT_DROP1_LABEL,

    TEMPLATE6_CONTACT_DROPDOWN1,
    TEMPLATE6_CONTACT_DROPDOWN2,
    TEMPLATE6_CONTACT_DROPDOWN3,
    TEMPLATE6_CONTACT_DROPDOWN4,
    TEMPLATE6_CONTACT_DROPDOWN5,
    TEMPLATE6_CONTACT_DROPDOWN6,
    TEMPLATE6_CONTACT_DROPDOWN7,
    TEMPLATE6_CONTACT_DROPDOWN8,
    TEMPLATE6_CONTACT_DROPDOWN9,
    TEMPLATE6_CONTACT_DROPDOWN10,
    TEMPLATE6_CONTACT_DROPDOWN11,
    TEMPLATE6_CONTACT_DROPDOWN12,
    TEMPLATE6_CONTACT_DROPDOWN13,


    //

    TEMPLATE6_HERO_TITLE,

    TEMPLATE6_HERO_SUBTITLE,

    TEMPLATE6_HERO_DESCRIPTION,
    BUTTON_QUOTE,

    BUTTON_CALL,

    TEMPLATE6_BADGE1,

    TEMPLATE6_BADGE2,

    TEMPLATE6_BADGE3,


    TEMPLATE6_SERVICE_SUBTITLE,
    TEMPLATE6_SERVICE_TITLE,

    TEMPLATE6_REVIEWS_SUBTITLE,
    TEMPLATE6_REVIEWS_TITLE,


    TEMPLATE6_WHY_CHOOSE_SUBTITLE,
    TEMPLATE6_WHY_CHOOSE_TITLE,
    TEMPLATE6_WHY_CHOOSE_DESCRIPTION,

    TEMPLATE6_EXPERIENCE_YEARS,
    TEMPLATE6_EXPERIENCE_LABEL,

    TEMPLATE6_FAQ_SUBTITLE,
    TEMPLATE6_FAQ_TITLE,
    TEMPLATE6_FAQ_DESCRIPTION,

    TEMPLATE6_FAQ_CARD_TITLE,
    TEMPLATE6_FAQ_CARD_DESCRIPTION,
    TEMPLATE6_FAQ_CARD_BUTTON,



    TEMPLATE6_CONTACT_SUBTITLE,
    TEMPLATE6_CONTACT_TITLE,
    TEMPLATE6_CONTACT_DESCRIPTION,



    TEMPLATE6_FOOTER_DESCRIPTION,

    FOOTER_LINKS_TITLE,
    FOOTER_SERVICES_TITLE,
    FOOTER_CONTACT_TITLE,

    FOOTER_SERVICE_FAULTS,
    FOOTER_SERVICE_REWIRES,

    FOOTER_PRIVACY,
    FOOTER_TERMS,
    ;


    override val keyName: String
        get() = name


}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(

        ResKey.TEMPLATE6_SECTION1 to "Home",
        ResKey.TEMPLATE6_SECTION2 to "Services",
        ResKey.TEMPLATE6_SECTION3 to "Why choose us?",
        ResKey.TEMPLATE6_SECTION4 to "Contact",
        ResKey.TEMPLATE6_SECTION5 to "FAQ",
        ResKey.TEMPLATE6_SECTION6 to "Reviews",



        ResKey.TEMPLATE6_REVIEW1_TITLE to "Professional and Reliable",
        ResKey.TEMPLATE6_REVIEW1 to "EasyWire arrived on time, diagnosed the issue quickly, and fixed it efficiently. Highly recommended!",

        ResKey.TEMPLATE6_REVIEW2_TITLE to "Excellent Customer Service",
        ResKey.TEMPLATE6_REVIEW2 to "Friendly, knowledgeable, and very helpful. EasyWire made the whole process stress-free and explained everything clearly.",

        ResKey.TEMPLATE6_REVIEW3_TITLE to "Quick and Efficient",
        ResKey.TEMPLATE6_REVIEW3 to "Had an emergency electrical fault at home. EasyWire responded promptly and resolved it in no time. Fantastic service!",

        ResKey.TEMPLATE6_REVIEW4_TITLE to "Trustworthy Electrician",
        ResKey.TEMPLATE6_REVIEW4 to "I always trust EasyWire for all my electrical needs. Honest pricing, great work, and very professional.",

        ResKey.TEMPLATE6_REVIEW5_TITLE to "High-Quality Work",
        ResKey.TEMPLATE6_REVIEW5 to "From installing new lighting to upgrading my panel, EasyWire does top-notch work every time. Wouldn’t go anywhere else.",

        ResKey.TEMPLATE6_REVIEW6_TITLE to "Friendly and Knowledgeable",
        ResKey.TEMPLATE6_REVIEW6 to "EasyWire is approachable, explains the work clearly, and completes it safely. Always a pleasure to work with.",
        ResKey.TEMPLATE6_REVIEW7_TITLE to "Fast Response Time",
        ResKey.TEMPLATE6_REVIEW7 to "Contacted EasyWire in the morning and the issue was fixed the same day. Very responsive and efficient service.",

        ResKey.TEMPLATE6_REVIEW8_TITLE to "Clear Pricing and Great Advice",
        ResKey.TEMPLATE6_REVIEW8 to "EasyWire provided a clear quote upfront and offered helpful advice without any pressure. Excellent and honest service.",

        ResKey.TEMPLATE6_REVIEW9_TITLE to "Professional From Start to Finish",
        ResKey.TEMPLATE6_REVIEW9 to "From the first call to the completed job, EasyWire was professional, tidy, and reliable. Highly recommended electrician.",




        ResKey.TEMPLATE6_INFO_FOOTER to "Choosing EasyWire means choosing peace of mind. Whether it’s installing new lighting, upgrading your panel, or fixing a fault, we bring expertise, professionalism, and a commitment to quality with every job.",

        ResKey.CONTACT_DROP1 to "Select type of work",
        ResKey.CONTACT_DROP1_LABEL to "Type of electrical work",


        ResKey.TEMPLATE6_CONTACT_DROPDOWN1 to "Select work type",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN2 to "Emergency Electrical Fault",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN3 to "Consumer Unit / Fuse Board Upgrade",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN4 to "Electrical Inspection (EICR)",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN5 to "Rewiring",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN6 to "Additional Sockets",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN7 to "Lighting Installation",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN8 to "Outdoor / Garden Lighting",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN9 to "EV Charger Installation",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN10 to "Smoke Alarms",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN11 to "Landlord Electrical Certificate",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN12 to "Commercial Electrical Work",
        ResKey.TEMPLATE6_CONTACT_DROPDOWN13 to "Other",


        ////
        ResKey.TEMPLATE6_HERO_TITLE to "Reliable Electrical Services You Can Trust",

        ResKey.TEMPLATE6_HERO_SUBTITLE to "Professional. Safe. On Time. Every Time.",

        ResKey.TEMPLATE6_HERO_DESCRIPTION to
                "EasyWire provides expert electrical services for homes and businesses. From installations and rewires to emergency call-outs, we deliver quality workmanship you can rely on.",

        ResKey.BUTTON_QUOTE to "Get a Free Quote",

        ResKey.BUTTON_CALL to "Call Now",

        ResKey.TEMPLATE6_BADGE1 to "Fully Qualified & Insured",

        ResKey.TEMPLATE6_BADGE2 to "24/7 Emergency Services",

        ResKey.TEMPLATE6_BADGE3 to "Customer Satisfaction Guaranteed",

        ResKey.TEMPLATE6_SERVICE_SUBTITLE to "Our Services",
        ResKey.TEMPLATE6_SERVICE_TITLE to "Complete Electrical Solutions",
        ResKey.TEMPLATE6_REVIEWS_SUBTITLE to "What Our Clients Say",
        ResKey.TEMPLATE6_REVIEWS_TITLE to "Trusted by Homeowners & Businesses",
        ResKey.TEMPLATE6_SERVICE1_TITLE to "Domestic Electrical",
        ResKey.TEMPLATE6_SERVICE1_DESC1 to "Full house rewires",
        ResKey.TEMPLATE6_SERVICE1_DESC2 to "Lighting installations",
        ResKey.TEMPLATE6_SERVICE1_DESC3 to "Consumer unit upgrades",
        ResKey.TEMPLATE6_SERVICE1_DESC4 to "Fault finding & repairs",

        ResKey.TEMPLATE6_SERVICE2_TITLE to "Commercial Electrical",
        ResKey.TEMPLATE6_SERVICE2_DESC1 to "Office & retail fit-outs",
        ResKey.TEMPLATE6_SERVICE2_DESC2 to "Electrical maintenance",
        ResKey.TEMPLATE6_SERVICE2_DESC3 to "Emergency lighting",
        ResKey.TEMPLATE6_SERVICE2_DESC4 to "Inspection & testing",

        ResKey.TEMPLATE6_SERVICE3_TITLE to "Emergency Call-Outs",
        ResKey.TEMPLATE6_SERVICE3_DESC1 to "24/7 emergency response",
        ResKey.TEMPLATE6_SERVICE3_DESC2 to "Power outages",
        ResKey.TEMPLATE6_SERVICE3_DESC3 to "Fault diagnostics",
        ResKey.TEMPLATE6_SERVICE3_DESC4 to "Safe temporary repairs",

        ResKey.TEMPLATE6_WHY_CHOOSE_SUBTITLE to "Why Choose EasyWire?",
        ResKey.TEMPLATE6_WHY_CHOOSE_TITLE to "Professional Electrical Services Backed by Experience",
        ResKey.TEMPLATE6_WHY_CHOOSE_DESCRIPTION to "Whether you need a small repair or a complete installation, our experienced electricians deliver reliable workmanship, clear communication, and exceptional customer service from start to finish.",

        ResKey.TEMPLATE6_EXPERIENCE_YEARS to "10+",
        ResKey.TEMPLATE6_EXPERIENCE_LABEL to "Years of Experience",

        ResKey.TEMPLATE6_INFO_TITLE1 to "Fully Qualified & Insured",
        ResKey.TEMPLATE6_INFO_DESC1 to "Qualified electricians delivering safe, compliant electrical work you can trust.",

        ResKey.TEMPLATE6_INFO_TITLE2 to "Fast Response Times",
        ResKey.TEMPLATE6_INFO_DESC2 to "We arrive on time and complete work efficiently while maintaining the highest standards.",

        ResKey.TEMPLATE6_INFO_TITLE3 to "Transparent Pricing",
        ResKey.TEMPLATE6_INFO_DESC3 to "Clear quotes with no hidden fees, so you always know exactly what to expect.",

        ResKey.TEMPLATE6_INFO_TITLE4 to "Customer Satisfaction",
        ResKey.TEMPLATE6_INFO_DESC4 to "We take pride in our workmanship and aren't satisfied until you are.",

        ResKey.TEMPLATE6_FAQ_SUBTITLE to "Frequently Asked Questions",
        ResKey.TEMPLATE6_FAQ_TITLE to "Have Questions?",
        ResKey.TEMPLATE6_FAQ_DESCRIPTION to "We've answered the questions we're asked most often. If you still need help, give us a call and we'll be happy to assist.",

        ResKey.TEMPLATE6_FAQ_CARD_TITLE to "Still Have Questions?",
        ResKey.TEMPLATE6_FAQ_CARD_DESCRIPTION to "Speak directly with one of our friendly electricians for free advice or to arrange a quote.",
        ResKey.TEMPLATE6_FAQ_CARD_BUTTON to "Call Now",

        ResKey.TEMPLATE6_FAQ1_Q to "Do you offer emergency electrical call-outs?",
        ResKey.TEMPLATE6_FAQ1_A to "Yes. We provide rapid emergency electrical services for homes and businesses whenever possible.",

        ResKey.TEMPLATE6_FAQ2_Q to "Do you provide free quote?",
        ResKey.TEMPLATE6_FAQ2_A to "Yes. Every quote is completely free with no obligation to proceed.",

        ResKey.TEMPLATE6_FAQ3_Q to "Are you fully qualified and insured?",
        ResKey.TEMPLATE6_FAQ3_A to "Absolutely. All work is carried out by qualified electricians and is fully insured for your peace of mind.",

        ResKey.TEMPLATE6_FAQ4_Q to "What areas do you cover?",
        ResKey.TEMPLATE6_FAQ4_A to "We cover Stafford, Stoke-on-Trent, Lichfield, Hixon, Great Haywood, Gnosall and surrounding areas.",

        ResKey.TEMPLATE6_FAQ5_Q to "Can you install EV chargers?",
        ResKey.TEMPLATE6_FAQ5_A to "Yes. We install domestic and commercial EV charging points to current UK regulations.",

        ResKey.TEMPLATE6_FAQ6_Q to "What payment methods do you accept?",
        ResKey.TEMPLATE6_FAQ6_A to "We accept bank transfer, cash and all major debit and credit cards.",

        ResKey.TEMPLATE6_CONTACT_SUBTITLE to "Contact Us",
        ResKey.TEMPLATE6_CONTACT_TITLE to "Get in Touch Today",
        ResKey.TEMPLATE6_CONTACT_DESCRIPTION to "Whether you need a free quote, planned electrical work, or urgent assistance, our friendly team is ready to help. Send us a message and we'll get back to you as soon as possible.",


        ResKey.TEMPLATE6_FOOTER_DESCRIPTION to "Professional electrical services you can rely on. Safe, reliable and fully certified for domestic and commercial work.",

        ResKey.FOOTER_LINKS_TITLE to "Quick Links",
        ResKey.FOOTER_SERVICES_TITLE to "Our Services",
        ResKey.FOOTER_CONTACT_TITLE to "Contact",

        ResKey.FOOTER_SERVICE_FAULTS to "Fault Finding",
        ResKey.FOOTER_SERVICE_REWIRES to "Rewires",

        ResKey.FOOTER_PRIVACY to "Privacy Policy",
        ResKey.FOOTER_TERMS to "Terms & Conditions",


    ),
)
